module.exports = __webpack_public_path__ + "assets/85df6daf680b36193f3f1854211ab949.png";